/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"RegistrationReglament":"RegistrationReglament_0ylGq"};